

 var obj = JSON.parse(json);

var avails = {};

jQuery(document).ready(function() {

  // var colourName = jQuery("h2.name span#shoe-colour").html();
  // if(colourName.length > 0) {
  //   console.log('colour name: ' + colourName);
  //   const namedColour = (element) => element === colourName;
  //   if(obj.findIndex(namedColour) < 0) {
  //     jQuery(colourName).html(''); 
  //   }
  // }
  
 
  jQuery("select#ProductSelect-product-template option:enabled").each(function() {
    sku = jQuery(this).val();
    size_raw = jQuery(this).text();
    start = size_raw.indexOf("/");
    sizeFull = size_raw.substring(start + 2);
    size = sizeFull.replace(".", "");
    selectId = "size" + size;    
    Object.assign(avails, {variantId: sku, optionId: selectId});
    avails[sku] = selectId;

  });
  jQuery("li#slide-item-1542751785078 > div > div > img").wrap("<a href='https://ronwhiteshoes.com/collections/womens-sale'></a>");

  
  
    

});


/*
jQuery( window ).on( "load", function() { 	
  
  var swatch = jQuery("span.webyzeSwatches>.swatchColor.currentSwatch").data().name;

  //jQuery("h2.name span#shoe-colour").html(obj["colours"][swatch]);
  jQuery("h2.name span#shoe-colour").html(obj[swatch]);

  jQuery("div.swatch-element.sold_out").hide();
  jQuery("div.swatch-element.unavailable").hide();
  jQuery("div.swatch-element.available").show();

});
*/


jQuery(document).on("click", "span.swatchColor.swatchType_image", function(evt) {
  	var firstChild = "";

  	var swatch = $(this).data().name;
  
    console.log('swatch: ' + swatch);

  	//jQuery("h2.name span#shoe-colour").html(obj["colours"][swatch]);
   // const namedColour = (element) => element === colourName;
   //  if(obj.findIndex(namedColour) < 0) {
   //    jQuery("h2.name span#shoe-colour").html(''); 
   //  } else {
      
   //  }
  	
jQuery("h2.name span#shoe-colour").html(obj[swatch]);

	jQuery("select#ProductSelect-product-template option").each(function(){
	

        optName = jQuery(this).text().toLowerCase();
        optVal = jQuery(this).val();

        if(optName.indexOf(swatch) > -1){
          
            size_raw = jQuery(this).text();
            start = size_raw.indexOf("/");
            sizeFull = size_raw.substring(start + 2);
            size = sizeFull.replace(".", "");
            sizeClass = "size" + size;  
          	
          var i = 0;
          
            if(optName.indexOf("available size") < 0 ){
              
//                 console.log("Available:" + "div.swatch-element." + sizeClass);
              	jQuery("div.swatch-element." + sizeClass).removeClass("sold_out").addClass("available");
              if(i < 1) {
                firstChild = sizeClass.replace("size", "#swatch-1-");
              }
              
            } else {
              
              sizeClass = sizeClass.replace(' - Select an available size','');
//               console.log("Out of Stock: div.swatch-element." + sizeClass);
              jQuery("div.swatch-element." + sizeClass).removeClass("available").addClass("sold_out");
              
            }
          
        }
    });   
  
//   	jQuery(firstChild).addClass("selected");
//   console.log(firstChild + " div input");

  	jQuery("div.swatch-element.sold_out").hide();
  	jQuery("div.swatch-element.unavailable").hide();
    jQuery("div.swatch-element.available").show();

});



